<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="description" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="outTradeNo" label="商户订单号" align="center"></el-table-column>
                <!-- <el-table-column prop="phoneType" label="充值设备" align="center">
                    <template slot-scope="scope">
                        {{scope.row.phoneType == 0?'通用':''}}
                        {{scope.row.phoneType == 1?'华为':''}}
                        {{scope.row.phoneType == 2?'小米':''}}
                        {{scope.row.phoneType == 3?'Oppo':''}}
                        {{scope.row.phoneType == 4?'Vivo':''}}
                        {{scope.row.phoneType == 5?'三星':''}}
                        {{scope.row.phoneType == 10?'苹果':''}}
                        {{scope.row.phoneType == 11?'荣耀':''}}
                        {{scope.row.phoneType == 20?'h5':''}}
                    </template>
                </el-table-column> -->
                <el-table-column prop="device_info" label="设备号" align="center"></el-table-column>
                <el-table-column prop="total" label="支付金额" align="center"></el-table-column>
                <el-table-column prop="attach" label="附加数据" align="center"></el-table-column>
                <el-table-column prop="nickName" label="用户昵称" align="center"></el-table-column>
                <el-table-column prop="monthMember" label="会员时间" align="center"></el-table-column>
                <el-table-column prop="payType" label="支付类型" align="center">
                    <template slot-scope="scope">
                        {{scope.row.payType == 1?'会员':''}}
                        {{scope.row.payType == 2?'充值金币':''}}
                    </template>
                </el-table-column>
                <el-table-column prop="payState" label="支付结果" align="center">
                    <template slot-scope="scope">
                        {{scope.row.payState == 0?'未支付':(scope.row.payState == 1?'支付完成':scope.row.payState)}}
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="180px">
                </el-table-column>
                
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="500px">
            <forms ref="formListAdd" :list="formList" :value="formData" :rules="formRules" :btns="formAddBtns" labelWidth="120px"></forms>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <forms ref="formListEdit" :list="formList" :value="formData" :rules="formRules" :btns="formEditBtns" labelWidth="120px"></forms>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],

            conditionData:{
                // out_trade_no:'',
                // UserId:'',
                // PayType:'',
                PayState:1,
                // StartTime:'',
                // EndTime:'',
                Phone:'',
                current:1,
                size:10,
                payMethed:2,
            },
            queryList:[
                {type: "input",label: "手机:",name: "Phone"},
                {type: "input",label: "商户订单号:",name: "out_trade_no",},
                {type: "select",label: "支付类型:",name: "PayType",options:wtlxList},
                {type: "select",label: "支付结果:",name: "PayState",options:isNewList},
                {type: "datetime",label: "开始时间:",name: "StartTime"},
                {type: "datetime",label: "结束时间:",name: "EndTime"},
            ],

            formData:{
                Name:'',
                Type:'',
                UnderwritingAgency:'',
                IsNew:'',
            },
            formList:[
                {type: "input",label: "委托主体名称:",name: "Name",},
                {type: "select",label: "委托主体类型:",name: "Type",options:wtlxList},
                {type: "input",label: "承保机构:",name: "UnderwritingAgency",},
                {type: "select",label: "是否新来源:",name: "IsNew",options:isNewList},
            ],
            // 提交规则
            formRules:{
                Name: [{ required: true, message: '请填写委托主体名称', trigger: 'blur' }],
                Type: [{ required: true, message: '请填写委托主体类型', trigger: 'change' }],
                UnderwritingAgency: [{ required: true, message: '请填写承保机构', trigger: 'blur' }],
                IsNew: [{ required: true, message: '请填写是否新来源', trigger: 'change' }],
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.PayInfoSelectByPage(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                PayState:1,
                // StartTime:'',
                // EndTime:'',
                Phone:'',
                current:1,
                size:10,
                payMethed:2,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        // 新增弹窗
        showAddDialog(e){
            this.isAddDialog = true;
        },
        // 新增方法
        async add(){
            let flag = this.$refs["formListAdd"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.InsuranceCompanyAdd(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.$refs["formListAdd"].resetFields();
                this.loadingData();
            }
        },
        isUpdateDialogShow(row){
            console.log(row);
            this.isUpdateDialog = true;
            this.formData = {
                id:row.id,
                Name:row.name,
                Type:row.type,
                UnderwritingAgency:row.underwritingAgency,
                IsNew:row.isNew,
            }
        },
        // 编辑方法
        async edit(){
            let flag = this.$refs["formListEdit"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.InsuranceCompanyEdit(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.$refs["formListEdit"].resetFields();
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }
        },
        // 删除提示
        deleteRowTip(row){
            this.$confirm('将删除委托主体——'+row.name+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRow(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除方法
        async deleteRow(row){
            let res  = await api.InsuranceCompanyDel({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
   
</style>
